import qrCodeService from 'qrcode'
import {useEffect, useLayoutEffect, useRef, useState} from "react";
import cx from "classnames";
import useWindowSize from "@/hooks/useWindowSize";

export interface QRCodeProps {
    value: string;
    width: number | string;
    description?: string;
    className?: string;
}

export default function QRCode({value, width, description, className}: QRCodeProps) {
    const canvasRef = useRef<any>(null);

    const [qrCodeWidth, setQRCodeWidth] = useState<number | string>(typeof width === 'number' ? width : 200);

    const [windowWidth] = useWindowSize();

    useLayoutEffect(() => {
        if (!canvasRef?.current) return;

        if (windowWidth >= 1600) {
            const calculateWidth = window.innerWidth * 0.15;

            setQRCodeWidth(calculateWidth < 240 ? calculateWidth : 240);

            return;
        }

        if (windowWidth >= 1024) {
            setQRCodeWidth(160);

            return;
        }

        if (windowWidth >= 768) {
            setQRCodeWidth(120);

            return;
        }

        if (windowWidth >= 640) {
            setQRCodeWidth(80);

            return;
        }

        setQRCodeWidth(100);
    }, [windowWidth]);

    useLayoutEffect(() => {
        if (!canvasRef?.current) return;

        qrCodeService.toCanvas(canvasRef.current, value, {width: qrCodeWidth});
    }, [canvasRef, value, qrCodeWidth]);

    return (
        <div className={cx('flex flex-col justify-center items-center rounded mx-auto overflow-hidden', className)}>
            {description && <p className="flex-1 text-center whitespace-break-spaces text-xs lg:text-2xl">{description}</p>}
            <canvas className="flex-1 m-1 rounded" width={qrCodeWidth} height="auto" ref={canvasRef} id="canvas"></canvas>
            <p className="flex-1 p-2 text-xs lg:text-lg">Sign up free at <span className="text-sm underline">https://MyWeed.Club</span></p>
        </div>
    );
}